import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPauseCircleSmall = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Frame",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M12 22.0002C6.47715 22.0002 2 17.523 2 12.0002C2 6.47739 6.47715 2.00024 12 2.00024C17.5228 2.00024 22 6.47739 22 12.0002C22 17.523 17.5228 22.0002 12 22.0002ZM9 9.00024V15.0002H11V9.00024H9ZM13 9.00024V15.0002H15V9.00024H13Z",
			fill: "#0587FB"
		})
	})
});
export default SvgPauseCircleSmall;
